import React, { useState, useEffect, useRef } from "react";
import InputCatalogoCuentas from "../util/Inputs/InputCatalogoCuentas";
import ModalSeleccionCuenta from "../util/ModalSeleccionCuenta";
import TablaDinamica from "../util/TablaDinamica";
import FuncionesInventario from "./Funciones/FuncionesMantenimientoProducto";
import DockVerticalDerecha from "../estructura/DockVerticalDerecha";
import SpinnerCargando from "../util/SpinnerCargando";
import instanciaAxios, { esErrorPermiso } from "../../miscelaneo/instanciaAxios";
import { PESABLE } from "../../miscelaneo/constantes";
import {
  visible,
  tab_precio,
  tab_combo,
} from "../../miscelaneo/Caracteristica";
import { useContextoSesion } from "../../miscelaneo/ContextoSesion";
import { toast } from "react-toastify";
import axios from "axios";
import PlantillaModal from "../util/PlantillaModal";
import ModalConfirmacion from "../util/ModalConfirmacion";
import TablaProducto from "../util/tablas/TablaProducto";
import { MdWarning } from "react-icons/md";
import { FiDownload, FiPrinter } from "react-icons/fi";
import { esNumeroNoNegativo } from "../util/ValidacionesCampos";
import ModalFlejeProducto from "./ModalFlejeProducto";
function MantenimientoProducto() {
  const { tienePermiso } = useContextoSesion();
  const puedeDesactivarProducto = tienePermiso("inventario_desactivar_producto");
  const exportarConfigRef = useRef({ habilitado: false, nombreArchivo: '' });

  useEffect(() => {
    instanciaAxios.get('/miscelaneo/configuracion')
      .then((res) => {
        exportarConfigRef.current = {
          habilitado: res.data?.exportar_linea_pesable ?? false,
          nombreArchivo: res.data?.nombre_archivo_exportacion_pesable || ''
        };
      })
      .catch(() => {});
  }, []);

  function formatearPrecioBalanza(precio) {
    return Math.round(Number(precio) * 100).toString();
  }

  function construirLineaProductoPesable(codigo_producto, descripcion, precio) {
    const descripcionLimpia = String(descripcion || "").replace(/\r?\n/g, " ").trim();
    return `1,${codigo_producto},1,${descripcionLimpia},,${formatearPrecioBalanza(precio)},0`;
  }

  function descargarArchivoTXT(contenido, nombreBase) {
    const blob = new Blob([contenido], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${nombreBase}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  function descargarLineaProducto(codigo_producto, descripcion, precio) {
    const contenido = construirLineaProductoPesable(codigo_producto, descripcion, precio);
    const nombreBase = exportarConfigRef.current.nombreArchivo?.trim() || `producto_${codigo_producto}`;
    descargarArchivoTXT(contenido, nombreBase);
  }

  const [productoSeleccionado, setProductoSeleccionado] = useState();
  const [exportandoTodosPesables, setExportandoTodosPesables] = useState(false);
  const [modo, setModo] = useState("creacion");
  const [editable, setEditable] = useState({});
  const [mostrarModalProducto, setMostrarModalProducto] = useState(false);
  const [verProductosDesactivados, setVerProductosDesactivados] = useState(false);
  const [actualizandoEstadoProducto, setActualizandoEstadoProducto] = useState(false);
  const [confirmacionEstado, setConfirmacionEstado] = useState({
    mostrar: false,
    estadoDestino: null,
    accion: "",
    titulo: "",
    mensaje: "",
    textoConfirmar: "Confirmar",
    tipo: "warning",
  });
  const [mostrarModalFleje, setMostrarModalFleje] = useState(false);
  const { generarCamposFormulario, ObtenerProductoDetallado } =
    FuncionesInventario();
  const [esServicio, setEsServicio] = useState(false);
  const [nombresProductos, setNombresProductos] = useState([]);
  //const [inventarioEditable,setInventarioEditable] = useState(false);
  const inventarioEditable = false;
  const [tabsVisibles, setTabsVisibles] = useState({
    producto: {
      general: true,
      inventario: true,
      precios: tab_precio,
      combo: tab_combo,
    },
    servicio: {
      general: true,
      inventario: false,
      precios: tab_precio,
      combo: tab_combo,
    },
    combo: {
      general: false,
      inventario: false,
      combo: tab_combo,
      precios: tab_precio,
    },
  });
  useEffect(() => {
    setEditable(modo !== "ver");
    if (modo === "ver") {
      setProductoSeleccionado(null);
      toast.info("Modo solo observación");
    }
    if (modo === "edicion") {
      setProductoSeleccionado(null);
      toast.info("Modo edición");
    }
    if (modo === "creacion") {
      limpiarCampos();
      setProductoSeleccionado(null);

      // limpiarCampos(camposFormulario,setFormData,setTabsActivos,setNombresCuentas);
      toast.info("Modo creación");
    }
  }, [modo]);

  function limpiarCampos() {
    const initialData = {};
    camposFormulario.forEach((campo) => {
      initialData[campo.id] = "";
    });
    initialData.tipos_entidad = [];

    setFormData({
      costo_inicial: '',  // Vacío para UX, se muestra placeholder
      precio: '',  // Vacío para UX
      precio_total: '',  // Vacío para UX
      indicador_facturacion: 1, // Default: Gravado 18%
      impuesto: [], // Mantener para compatibilidad
      origen: 1,
      venta_negativo: false,
      es_pesable: false,
      id_tipo_producto: 1,
    });

    setOpcionesTabs({
      producto: true,
      servicio: true,
      combo: tab_combo,
    });

    // Restaurar tabs visibles por defecto (con inventario visible para nuevos productos)
    setTabsVisibles({
      producto: {
        general: true,
        inventario: true,
        precios: tab_precio,
        combo: tab_combo,
      },
      servicio: {
        general: true,
        inventario: false,
        precios: tab_precio,
        combo: tab_combo,
      },
      combo: {
        general: false,
        inventario: false,
        combo: tab_combo,
        precios: tab_precio,
      },
    });

    handleFiltro("producto");

    setNombresCuentas({});
  }
  async function handleSeleccionarProducto(producto) {
    try {
      limpiarCampos();
      setMostrarModalProducto(false);
      setVerProductosDesactivados(false);
      const id_producto = producto[0];
      setProductoSeleccionado(id_producto);
      const datos = await ObtenerProductoDetallado(id_producto);

      // Verificar si hay inventario disponible
      const tieneInventario = datos.inventario && datos.inventario.length > 0;

      if (datos.id_tipo_producto == "1") {
        setOpcionesTabs({
          producto: true,
        });
        setTabSeleccionado("general");

        // Actualizar tabs visibles dinámicamente basado en si hay inventario
        setTabsVisibles((prev) => ({
          ...prev,
          producto: {
            ...prev.producto,
            inventario: tieneInventario,
          },
        }));

        setNombresCuentas((prevFormData) => ({
          ...prevFormData,
          //Nombres cuentas
          id_cuenta_contable_inventario:
            datos.nombre_cuenta_contable_inventario,
        }));
      } else if (datos.id_tipo_producto == "2") {
        setOpcionesTabs({
          servicio: true,
        });
        setTabSeleccionado("general");
      } else if (datos.id_tipo_producto == "3") {
        setOpcionesTabs({
          combo: true,
        });
        setTabSeleccionado("combo");

        setFormData((prev) => ({
          ...prev,
          comentario: datos.comentario,
          detalleCombo: datos.detalles_combo,
        }));

        setNombresProductos((prev) => [
          ...prev,
          ...(Array.isArray(datos?.detalles_combo)
            ? datos.detalles_combo.map((producto) => ({
                value: producto.id_producto,
                label: producto.descripcion,
              }))
            : []),
        ]);
      }

      setNombresCuentas((prevFormData) => ({
        ...prevFormData,
        //Nombres cuentas
        id_cuenta_contable_venta_contado:
          datos.nombre_cuenta_contable_venta_contado,
        id_cuenta_contable_venta_credito:
          datos.nombre_cuenta_contable_venta_credito,
      }));

      if (datos.id_tipo_producto == "1" || datos.id_tipo_producto == "2") {
        setNombresCuentas((prevFormData) => ({
          ...prevFormData,
          //Nombres cuentas
          id_cuenta_contable_costo: datos.nombre_cuenta_contable_costo,
        }));
      }

      setFormData((prev) => ({
        ...prev,
        id_producto: id_producto,
        codigo_producto: datos.codigo_producto,
        descripcion: datos.descripcion,
        referencia: datos.referencia,
        codigo_barra: datos.codigo_barra,
        id_unidad_medida: datos.id_unidad_medida,
        id_categoria: datos.id_categoria,
        id_marca: datos.id_marca,
        id_tipo_producto: datos.id_tipo_producto,
        id_estado: datos.id_estado,
        costo_inicial: datos.costo_inicial,
        costo_ultimo: datos.costo_ultimo,
        costo_promedio: datos.costo_promedio,
        precio: datos.precio,
        precio_total: datos.precio_total,
        venta_negativo: datos.venta_negativo,
        es_pesable: datos.es_pesable ?? false,
        origen: datos.origen,
        id_cuenta_contable_venta_contado:
          datos.id_cuenta_contable_venta_contado,
        id_cuenta_contable_venta_credito:
          datos.id_cuenta_contable_venta_credito,
        id_cuenta_contable_costo: datos.id_cuenta_contable_costo,
        id_cuenta_contable_inventario: datos.id_cuenta_contable_inventario,
        indicador_facturacion: datos.indicador_facturacion !== null && datos.indicador_facturacion !== undefined ? datos.indicador_facturacion : 1,
      }));
      if (datos.lista_precios) {
        const listaprecio = datos.lista_precios.map(({ precio, ...resto }) => ({
          valor: precio,
          ...resto,
        }));

        if (listaprecio) {
          setFormData((prev) => ({
            ...prev,
            detalleListaPrecio: listaprecio,
          }));
        }
      }

      if (datos.inventario) {
        setFormData((prev) => ({
          ...prev,
          detalleInventario: datos.inventario,
        }));
      }
    } catch (error) {
      if (esErrorPermiso(error)) return;
      console.error('Error al obtener producto:', error);
      const mensajeError = error.response?.data?.mensaje || error.response?.data?.message || 'Error al obtener producto';
      toast.error(mensajeError);
    }
  }

  function cerrarModalProducto() {
    setMostrarModalProducto(false);
    setVerProductosDesactivados(false);
  }

  function cerrarConfirmacionEstado() {
    setConfirmacionEstado({
      mostrar: false,
      estadoDestino: null,
      accion: "",
      titulo: "",
      mensaje: "",
      textoConfirmar: "Confirmar",
      tipo: "warning",
    });
  }

  async function handleBotonBuscar() {
    try {
      setVerProductosDesactivados(false);
      setMostrarModalProducto(true);
      setModo("ver");
    } catch (error) {
      console.log(error);
    }
  }

  async function handleBotonEditar() {
    try {
      setVerProductosDesactivados(false);
      setMostrarModalProducto(true);
      setModo("edicion");
    } catch (error) {
      console.log(error);
    }
  }

  async function handleBotonCrear() {
    try {
      setModo("creacion");
    } catch (error) {
      console.log(error);
    }
  }

  async function handleExportarTodosPesables() {
    try {
      setExportandoTodosPesables(true);
      const respuesta = await instanciaAxios.get("/producto/pesables/export");
      const productosPesables = Array.isArray(respuesta?.data?.data)
        ? respuesta.data.data
        : Array.isArray(respuesta?.data)
          ? respuesta.data
          : [];

      if (productosPesables.length === 0) {
        toast.info("No hay productos pesables para exportar");
        return;
      }

      const lineas = productosPesables.map((producto) =>
        construirLineaProductoPesable(
          producto.codigo_producto,
          producto.descripcion,
          producto.precio_total ?? producto.precio
        )
      );

      const nombreBaseConfig = exportarConfigRef.current.nombreArchivo?.trim();
      const nombreArchivo = nombreBaseConfig ? `${nombreBaseConfig}_todos` : "productos_pesables";
      descargarArchivoTXT(lineas.join("\n"), nombreArchivo);
      toast.success(`Se exportaron ${productosPesables.length} productos pesables`);
    } catch (error) {
      if (esErrorPermiso(error)) return;
      const mensajeError = error.response?.data?.mensaje || "No se pudo exportar los productos pesables";
      toast.error(mensajeError);
    } finally {
      setExportandoTodosPesables(false);
    }
  }

  function handleCambiarEstadoProducto() {
    if (!puedeDesactivarProducto) {
      toast.error("No tiene permiso para desactivar o reactivar productos");
      return;
    }

    if (!formData.id_producto) {
      toast.error("Debe seleccionar un producto");
      return;
    }

    const estadoActual = Number(formData.id_estado) === 2 ? 2 : 1;
    const estadoDestino = estadoActual === 2 ? 1 : 2;
    const accion = estadoDestino === 2 ? "desactivar" : "reactivar";
    const mensajeConfirmacion =
      estadoDestino === 2
        ? "El producto se ocultará de compra, venta y operaciones de inventario. ¿Desea continuar?"
        : "El producto volverá a estar disponible en todos los procesos operativos. ¿Desea continuar?";

    setConfirmacionEstado({
      mostrar: true,
      estadoDestino,
      accion,
      titulo: estadoDestino === 2 ? "Desactivar producto" : "Reactivar producto",
      mensaje: `¿Seguro que desea ${accion} este producto?\n\n${mensajeConfirmacion}`,
      textoConfirmar: estadoDestino === 2 ? "Desactivar" : "Reactivar",
      tipo: estadoDestino === 2 ? "danger" : "info",
    });
  }

  async function confirmarCambioEstadoProducto() {
    const { estadoDestino, accion } = confirmacionEstado;
    if (!estadoDestino || !formData.id_producto) {
      cerrarConfirmacionEstado();
      return;
    }
    try {
      setActualizandoEstadoProducto(true);
      cerrarConfirmacionEstado();
      const { data } = await instanciaAxios.patch(`/producto/${formData.id_producto}/estado`, {
        id_estado: estadoDestino,
      });

      setFormData((prev) => ({
        ...prev,
        id_estado: data.id_estado,
      }));

      toast.success(data?.mensaje || `Producto ${accion}do correctamente`);
    } catch (error) {
      if (esErrorPermiso(error)) return;
      const mensajeError = error.response?.data?.mensaje || "No se pudo actualizar el estado del producto";
      toast.error(mensajeError);
    } finally {
      setActualizandoEstadoProducto(false);
    }
  }

  async function SubmitProducto() {
    if (guardandoProducto) return;
    // console.log(formData)
    // return

    // Preparar datos para enviar
    let datosParaEnviar = { ...formData };

    // Convertir campos numéricos vacíos a 0
    if (
      !datosParaEnviar.costo_inicial ||
      datosParaEnviar.costo_inicial === "" ||
      datosParaEnviar.costo_inicial === null
    ) {
      datosParaEnviar.costo_inicial = 0;
    }
    if (
      !datosParaEnviar.precio ||
      datosParaEnviar.precio === "" ||
      datosParaEnviar.precio === null
    ) {
      datosParaEnviar.precio = 0;
    }
    if (
      !datosParaEnviar.precio_total ||
      datosParaEnviar.precio_total === "" ||
      datosParaEnviar.precio_total === null
    ) {
      datosParaEnviar.precio_total = 0;
    }

    // Convertir campos FK vacíos a null (para evitar error de integer en PostgreSQL)
    if (!datosParaEnviar.id_categoria || datosParaEnviar.id_categoria === "") {
      datosParaEnviar.id_categoria = null;
    }
    if (!datosParaEnviar.id_marca || datosParaEnviar.id_marca === "") {
      datosParaEnviar.id_marca = null;
    }
    if (!datosParaEnviar.id_unidad_medida || datosParaEnviar.id_unidad_medida === "") {
      datosParaEnviar.id_unidad_medida = null;
    }

    // Asegurar valores por defecto para servicios
    if (datosParaEnviar.id_tipo_producto == "2") {
      datosParaEnviar.id_cuenta_contable_inventario = null;
      datosParaEnviar.id_unidad_medida = 43; // DGII code 43 = UND (Unidad)
    }

    if (datosParaEnviar.id_tipo_producto == "3") {
      if (
        !datosParaEnviar?.detalleCombo ||
        datosParaEnviar.detalleCombo.length < 2
      ) {
        toast.error("Son necesarios al menos 2 productos para crear un combo");
        return;
      }
    }
    if (
      datosParaEnviar.id_tipo_producto == "2" ||
      datosParaEnviar.id_tipo_producto == "3"
    ) {
      datosParaEnviar.detalleInventario = null;
    }

    //    console.log(datosParaEnviar);

    if (modo == "ver") {
      toast.error("Solo se pueden guardar cambios en modo edición o creación");
      return;
    }

    try {
      const errores = [
        {
          cond: !datosParaEnviar.descripcion,
          msg: "El campo descripcion es obligatorio",
        },

        {
          cond: !datosParaEnviar.precio,
          msg: "El campo precio es obligatorio",
        },
        // { cond: !datosParaEnviar.precio_total, msg: 'El campo precio total es obligatorio' },
        {
          cond: !datosParaEnviar.id_tipo_producto,
          msg: "El tipo de producto es obligatorio",
        },

        // Validaciones de números no negativos
        {
          cond: !esNumeroNoNegativo(datosParaEnviar.costo_inicial),
          msg: "El costo inicial no puede ser negativo",
        },
        {
          cond: !esNumeroNoNegativo(datosParaEnviar.precio),
          msg: "El precio no puede ser negativo",
        },
      ];

      // Validaciones específicas para productos (tipo 1)
      if (datosParaEnviar.id_tipo_producto == "1") {
        errores.push({
          cond: !datosParaEnviar.id_unidad_medida,
          msg: "El campo unidad de medida es obligatorio",
        });
        // errores.push({ cond: !datosParaEnviar.costo_inicial, msg: 'El campo costo inicial es obligatorio' })
        //---------------------------------- VALIDACION CUENTAS CONTABLES ------------------------------------
        // errores.push({ cond: !datosParaEnviar.id_cuenta_contable_venta_contado, msg: 'El campo cuenta contable venta contado es obligatorio' })
        // errores.push({ cond: !datosParaEnviar.id_cuenta_contable_venta_credito, msg: 'El campo cuenta contable venta crédito es obligatorio' })
        // errores.push({ cond: !datosParaEnviar.id_cuenta_contable_costo, msg: 'El campo cuenta contable costo es obligatorio' })
      }

      //   Validaciones específicas para servicios (tipo 2)
      //   if(datosParaEnviar.id_tipo_producto == '2'){
      //     Para servicios, la unidad de medida se establece automáticamente en 1
      //     errores.push({ cond: !datosParaEnviar.costo_inicial, msg: 'El campo costo inicial es obligatorio' })
      //     ---------------------------------- VALIDACION CUENTAS CONTABLES ------------------------------------
      //    errores.push({ cond: !datosParaEnviar.id_cuenta_contable_venta_contado, msg: 'El campo cuenta contable venta contado es obligatorio' })
      //    errores.push({ cond: !datosParaEnviar.id_cuenta_contable_venta_credito, msg: 'El campo cuenta contable venta crédito es obligatorio' })
      //    errores.push({ cond: !datosParaEnviar.id_cuenta_contable_costo, msg: 'El campo cuenta contable costo es obligatorio' })
      //  }

      // if(datosParaEnviar.id_tipo_producto == '1'){
      //   errores.push({ cond: !datosParaEnviar.id_cuenta_contable_inventario, msg: 'El campo cuenta contable inventario es obligatorio para productos' })
      // }

      for (let error of errores) {
        if (error.cond) {
          toast.error(error.msg);
          return;
        }
      }
      setGuardandoProducto(true);
      if (modo === "creacion") {
        const respuesta = await instanciaAxios.post("/producto", datosParaEnviar);
        // Para productos pesables, el backend genera el codigo_barra — actualizamos el form con el valor real.
        setFormData({
          ...datosParaEnviar,
          id_producto: respuesta.data.id_producto,
          codigo_producto: respuesta.data.codigo_producto,
          codigo_barra: respuesta.data.codigo_barra,
        });
        if (exportarConfigRef.current.habilitado && respuesta.data.es_pesable) {
          descargarLineaProducto(respuesta.data.codigo_producto, respuesta.data.descripcion, respuesta.data.precio_total);
        }
      }
      if (modo === "edicion") {
        await instanciaAxios.put("/producto", datosParaEnviar);
        setFormData(datosParaEnviar);
        if (exportarConfigRef.current.habilitado && datosParaEnviar.es_pesable) {
          descargarLineaProducto(formData.codigo_producto, datosParaEnviar.descripcion, datosParaEnviar.precio_total);
        }
      }

      setModo("ver");
      toast.success("Producto creado correctamente");
    } catch (error) {
      if (esErrorPermiso(error)) return;
      console.error('Error al registrar producto:', error);
      
      // Mostrar mensaje específico del backend (ej: duplicado de código de barras o referencia)
      const mensajeError = error.response?.data?.mensaje || error.response?.data?.message || 'Error al registrar producto';
      toast.error(mensajeError);
    } finally {
      setGuardandoProducto(false);
    }
  }

  const [cargando, setCargando] = useState();
  // Deshabilita el botón "Guardar" mientras se espera la respuesta del backend
  // (evita que un doble clic duplique el producto).
  const [guardandoProducto, setGuardandoProducto] = useState(false);
  const lastUpdatedRef = useRef(null);

  function handleChangeInventario(data) {
    const totalExistencia = data.reduce(
      (acc, item) => acc + Number(item.existencia),
      0,
    );

    setFormData((prev) => ({
      ...prev,
      detalleInventario: data,
      existencia_total: totalExistencia,
    }));
  }

  // Mapeo de indicador a tasa ITBIS
  const TASAS_ITBIS = { 1: 18, 2: 16, 3: 0, 4: 0 };

  const [formData, setFormData] = useState({
    costo_inicial: 0,
    precio: 0,
    precio_total: 0,
    indicador_facturacion: 1, // Default: Gravado 18%
    impuesto: [], // Mantener para compatibilidad temporal
    origen: 1,
    venta_negativo: false,
    es_pesable: false,
    id_tipo_producto: 1,
  });
  const estadoProductoActual = Number(formData.id_estado) === 2 ? 2 : 1;
  const productoEstaInactivo = estadoProductoActual === 2;
  const etiquetaEstadoProducto = productoEstaInactivo ? "Inactivo" : "Activo";

  useEffect(() => {
    if (formData.id_tipo_producto == "2") {
      handleFiltro("servicio");
      setFormData((prev) => ({
        ...prev,
        venta_negativo: true,
        id_unidad_medida: 1, // Establecer Unidad por defecto para servicios
        //  origen: 1
        venta_negativo: false,
      }));
      setEsServicio(true);
    } else if (formData.id_tipo_producto == "1") {
      handleFiltro("producto");
      setEsServicio(false);
    } else if (formData.id_tipo_producto == "3") {
      handleFiltro("combo");
      setEsServicio(false);
    }
  }, [formData.id_tipo_producto]);

  const [mostrarModalCuenta, setMostrarModalCuenta] = useState(false);
  const [cuentaSeleccionada, setCuentaSeleccionada] = useState(null);
  const [campoCuentaActivo, setCampoCuentaActivo] = useState(null); // ej. "cuenta_debito" o "cuenta_credito"
  const [nombresCuentas, setNombresCuentas] = useState({});
  const [camposFormulario, setCamposFormulario] = useState([]);

  const [tabSeleccionado, setTabSeleccionado] = useState("general");
  const [unidad_medida, setUnidadMedida] = useState([]);
  const [categoria, setCategoria] = useState([]);
  const [marca, setMarca] = useState([]);
  const [tipo_producto, setTipoProducto] = useState([]);
  const [impuesto, setImpuesto] = useState([]);
  const [sucursal, setSucursal] = useState([]);
  const [listas_precio, setListasPrecio] = useState([]);

  function HandleSeleccionarTab(tab) {
    if (formData.id_tipo_producto == "2" && tab == "inventario") {
      toast.error("Inventario no está disponible para servicios");
      return;
    }
    if (modo === "creacion" && tab === "inventario") {
      toast.error("Debe guardar el producto antes de ver el inventario");
      return;
    }
    setTabSeleccionado(tab);
  }
  // Función para calcular precio_total basado en precio e indicador_facturacion
  const calcularPrecioTotal = (precio, indicador) => {
    const base = parseFloat(precio) || 0;
    const tasa = TASAS_ITBIS[indicador] || 0;
    return Math.round((base + base * (tasa / 100)) * 100) / 100;
  };

  // Función inversa: calcular precio base a partir del precio total (con impuestos)
  const calcularPrecioBase = (precioTotal, indicador) => {
    const total = parseFloat(precioTotal) || 0;
    const tasa = TASAS_ITBIS[indicador] || 0;
    return Math.round((total / (1 + tasa / 100)) * 100) / 100;
  };

  // Cuando se modifica el precio, recalculamos el total
  useEffect(() => {
    if (lastUpdatedRef.current !== "precio") return;

    const { precio, indicador_facturacion } = formData;
    const newTotal = calcularPrecioTotal(precio, indicador_facturacion);

    if (Math.abs(newTotal - (parseFloat(formData.precio_total) || 0)) > 0.001) {
      setFormData((prev) => ({ ...prev, precio_total: newTotal }));
    }
    lastUpdatedRef.current = null;
  }, [formData.precio]);

  // Cuando se modifica el precio total, recalculamos el precio base
  useEffect(() => {
    if (lastUpdatedRef.current !== "precio_total") return;

    const { precio_total, indicador_facturacion } = formData;
    const newBase = calcularPrecioBase(precio_total, indicador_facturacion);

    if (Math.abs(newBase - (parseFloat(formData.precio) || 0)) > 0.001) {
      setFormData((prev) => ({ ...prev, precio: newBase }));
    }
    lastUpdatedRef.current = null;
  }, [formData.precio_total]);

  // Función para actualizar el indicador_facturacion
  function CalcularPrecio(indicadorSeleccionado) {
    const indicador = parseInt(indicadorSeleccionado) || 1;
    const newTotal = calcularPrecioTotal(formData.precio, indicador);

    setFormData((prev) => ({
      ...prev,
      indicador_facturacion: indicador,
      precio_total: newTotal,
    }));
  }

  // Cuando se modifica el indicador_facturacion, recalculamos el total
  useEffect(() => {
    if (lastUpdatedRef.current) return;

    const { precio, indicador_facturacion } = formData;
    const newTotal = calcularPrecioTotal(precio, indicador_facturacion);

    if (Math.abs(newTotal - (parseFloat(formData.precio_total) || 0)) > 0.001) {
      setFormData((prev) => ({ ...prev, precio_total: newTotal }));
    }
  }, [formData.indicador_facturacion]);

  // useEffect(() => {
  //   console.log(formData)
  // }, [formData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setCargando(true);
        const [
          unidad_medida,
          categorias,
          marcas,
          tipos_producto,
          impuestos,
          sucursales,
          listas_precio,
        ] = await Promise.all([
          instanciaAxios.get("/producto/unidad_medida"),
          instanciaAxios.get("/producto/categoria"),
          instanciaAxios.get("/producto/marca"),
          instanciaAxios.get("/producto/tipo_producto"),
          instanciaAxios.get("/miscelaneo/impuesto"),
          instanciaAxios.get("/miscelaneo/sucursal"),
          instanciaAxios.get("/miscelaneo/lista_precio"),
        ]);
        setSucursal(sucursales.data);
        setListasPrecio(listas_precio.data);
        setUnidadMedida(unidad_medida.data);
        setCategoria(categorias.data);
        setMarca(marcas.data);
        setTipoProducto(tipos_producto.data);
        setImpuesto(impuestos.data);

        const campos = generarCamposFormulario(
          unidad_medida.data,
          categorias.data,
          marcas.data,
          tipos_producto.data,
          impuestos.data,
          nombresCuentas,
          formData.indicador_facturacion,
        );
        setCamposFormulario(campos);
      } catch (error) {
        if (esErrorPermiso(error)) return;
        console.error("Error fetching data:", error);
        const mensajeError = error.response?.data?.mensaje || error.response?.data?.message || 'Error al cargar datos iniciales';
        toast.error(mensajeError);
      } finally {
        setCargando(false); // 2. Desactivar loading
      }
    };
    fetchData();
  }, []);
  // useEffect(() => {
  //   setCamposFormulario(generarCamposFormulario( nombresCuentas));
  // }, []);

  useEffect(() => {
    const nuevosCampos = generarCamposFormulario(
      unidad_medida,
      categoria,
      marca,
      tipo_producto,
      impuesto,
      nombresCuentas,
      formData.indicador_facturacion,
    );
    setCamposFormulario(nuevosCampos);
  }, [
    unidad_medida,
    categoria,
    marca,
    tipo_producto,
    impuesto,
    nombresCuentas,
    formData.indicador_facturacion,
  ]);

  const handleSeleccionCuenta = (cuenta) => {
    const campoId = campoCuentaActivo;

    // Actualizar formData con el valor correcto de la cuenta
    setFormData((prev) => ({
      ...prev,
      [campoId]: cuenta[0], // Asigna el ID de la cuenta
    }));

    // Actualizar nombresCuentas con el nombre de la cuenta
    setNombresCuentas((prev) => {
      const nuevo = { ...prev, [campoId]: cuenta[1] }; // Asigna el nombre de la cuenta
      return nuevo;
    });

    setCuentaSeleccionada(cuenta); // Guarda la cuenta seleccionada
    setMostrarModalCuenta(false); // Cierra el modal
  };

  const abrirModalCuenta = (campoId) => {
    setCampoCuentaActivo(campoId); // Guarda el campo activo para el que se abrirá el modal
    setMostrarModalCuenta(true);
  };

  const [tabs, setTabs] = useState({
    general: true,
    inventario: true,
    Precios: true,
    combo: true,
  });
  const [opcionesTabs, setOpcionesTabs] = useState({
    producto: true,
    servicio: true,
    combo: true,
  });

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;

    if (id === "precio" || id === "precio_total") {
      lastUpdatedRef.current = id;
    }

    setFormData((prev) => ({
      ...prev,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  //const campos =generarCamposFormulario(nombresCuentas);
  const camposFiltrados = camposFormulario.filter((campo) => {
    // Filtrar por tab
    if ((campo.tab ?? "general") !== tabSeleccionado) return false;

    // Insputs ocultos para servicios
    if (campo.id === "id_unidad_medida" && formData.id_tipo_producto == "2")
      return false;
    if (campo.id === "venta_negativo" && formData.id_tipo_producto == "2")
      return false;

    return true;
  });

  const camposPorSeccion = camposFiltrados.reduce((acc, campo) => {
    if (!acc[campo.seccion]) acc[campo.seccion] = [];
    acc[campo.seccion].push(campo);
    return acc;
  }, {});

  const [filtro, setFiltro] = useState("producto");

  // Estado para la pestaña activa (sección):

  // Handler para cambiar filtro:
  const handleFiltro = (nuevoFiltro) => {
    setFiltro(nuevoFiltro);
    if (nuevoFiltro == "producto") {
      setFormData((prev) => ({
        ...prev,
        id_tipo_producto: 1,
      }));
    } else if (nuevoFiltro == "servicio") {
      setFormData((prev) => ({
        ...prev,
        id_tipo_producto: 2,
      }));
    } else if (nuevoFiltro == "combo") {
      setFormData((prev) => ({
        ...prev,
        id_tipo_producto: 3,
      }));
    }
    // Buscamos la primera pestaña activa
    const primeraActiva = Object.entries(tabsVisibles[nuevoFiltro]).find(
      ([_, activo]) => activo,
    )?.[0];

    if (primeraActiva) {
      setTabSeleccionado(primeraActiva);
    }
  };

  return cargando ? (
    <SpinnerCargando />
  ) : (
    <div>
      <div className="flex justify-center">
        <div className="bg-gray-100 bg-opacity-90 rounded-xl border border-gray-100 p-12 w-full max-w-7xl">
          <form className="flex flex-col gap-8">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="space-y-1">
                <h1 className="font-cascadia font-bold text-2xl">Producto</h1>
                <p className="text-gray-500">
                  Complete los campos para registrar un nuevo producto o combo.
                </p>
              </div>
              <button
                type="button"
                onClick={handleExportarTodosPesables}
                disabled={exportandoTodosPesables}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-xl border border-color-primario text-color-primario text-sm font-medium hover:bg-color-primario hover:text-white transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <FiDownload size={16} />
                {exportandoTodosPesables ? "Exportando..." : "Exportar todos pesables"}
              </button>
            </div>
            {/** OPCIONEs TABS */}
            <div className="space-y-3">
              <h2 className="text-lg font-semibold">Tipo de producto</h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 mb-6">
                {Object.entries(opcionesTabs).map(
                  ([tab, activo]) =>
                    activo && (
                      <button
                        key={tab}
                        type="button"
                        onClick={() => handleFiltro(tab)}
                        className={`px-4 py-2 rounded-xl font-semibold border transition-colors duration-200 ${
                          filtro === tab
                            ? "bg-color-secundario text-white"
                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-200"
                        }`}
                      >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                      </button>
                    ),
                )}
              </div>
            </div>

            {/* TABS ACTIVOS */}
            <div className="space-y-3">
              <h2 className="text-lg font-semibold">
                Secciones relacionadas con producto
              </h2>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 mb-6">
                {Object.entries(tabsVisibles[filtro]).map(
                  ([tab, activo]) =>
                    activo && !(modo === "creacion" && tab === "inventario") && (
                      <button
                        key={tab}
                        type="button"
                        onClick={() => HandleSeleccionarTab(tab)}
                        className={`px-4 py-2 rounded-xl font-semibold border transition-colors duration-200 ${
                          tabSeleccionado === tab
                            ? "bg-color-secundario text-white"
                            : "bg-white text-gray-700 border-gray-300 hover:bg-gray-200"
                        }`}
                      >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                      </button>
                    ),
                )}
              </div>
            </div>

            {formData.codigo_producto && (
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                  <span className="text-sm font-medium text-gray-500">Código de producto</span>
                  <span className="font-cascadia font-bold text-color-primario text-lg tracking-widest">
                    {String(formData.codigo_producto).padStart(5, '0')}
                  </span>
                </div>
                <span
                  className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    productoEstaInactivo
                      ? "bg-red-100 text-red-700"
                      : "bg-emerald-100 text-emerald-700"
                  }`}
                >
                  Estado: {etiquetaEstadoProducto}
                </span>
                <button
                  type="button"
                  onClick={() => setMostrarModalFleje(true)}
                  title="Imprimir fleje"
                  className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-color-primario border border-color-primario rounded-xl hover:bg-color-primario hover:text-white transition-colors"
                >
                  <FiPrinter size={16} />
                  <span>Fleje</span>
                </button>
                {puedeDesactivarProducto && formData.id_producto && (
                  <button
                    type="button"
                    onClick={handleCambiarEstadoProducto}
                    disabled={actualizandoEstadoProducto}
                    className={`px-3 py-2 rounded-xl text-sm font-medium border transition-colors ${
                      productoEstaInactivo
                        ? "text-emerald-700 border-emerald-600 hover:bg-emerald-600 hover:text-white"
                        : "text-red-700 border-red-600 hover:bg-red-600 hover:text-white"
                    } ${actualizandoEstadoProducto ? "opacity-60 cursor-not-allowed" : ""}`}
                  >
                    {actualizandoEstadoProducto
                      ? "Procesando..."
                      : productoEstaInactivo
                        ? "Reactivar producto"
                        : "Desactivar producto"}
                  </button>
                )}
              </div>
            )}

            {Object.entries(camposPorSeccion).map(([titulo, campos]) =>
              titulo === "Contabilidad" && !visible ? null : (
                <div key={titulo}>
                  {!inventarioEditable && tabSeleccionado === "inventario" && (
                    <div className="mb-3 flex items-center gap-2 p-3 bg-yellow-100 border-l-4 border-yellow-500 rounded-md">
                      <MdWarning className="text-yellow-500 text-xl" />
                      <p className="text-yellow-700 font-medium">
                        El inventario solo es modificable mediante ajustes,
                        transfencia de inventario o compras.
                      </p>
                    </div>
                  )}
                  <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
                  <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(230px,_1fr))]">
                    {campos.map((campo) => (
                      <div key={campo.id} className="flex flex-col">
                        {campo.custom2 ? (
                          <div className="flex flex-col">
                            <label
                              htmlFor={campo.id}
                              className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1"
                            >
                              {campo.label}
                              {campo.required && <span className="text-red-500">*</span>}
                            </label>

                            {campo.custom2(
                              formData[campo.id],
                              editable
                                ? (datos) => CalcularPrecio(datos)
                                : () => {},
                              !editable,
                            )}
                          </div>
                        ) : campo.custom ? (
                          <div className="flex flex-col">
                            <label
                              htmlFor={campo.id}
                              className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1"
                            >
                              {campo.label}
                              {campo.required && <span className="text-red-500">*</span>}
                            </label>

                            {campo.custom(
                              formData[campo.id],
                              editable
                                ? () => abrirModalCuenta(campo.id)
                                : () => {},
                            )}
                          </div>
                        ) : campo.type === "checkbox" ? (
                          <div className="flex flex-col">
                            <label className="text-sm font-medium text-gray-600 mb-1">
                              {campo.label}
                            </label>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                if (esServicio) {
                                  toast.error(
                                    "Este campo no es modificable para servicios",
                                  );
                                  return;
                                }
                                if (!editable) return;
                                setFormData((prev) => ({
                                  ...prev,
                                  [campo.id]: !prev[campo.id],
                                }));
                              }}
                              className={`cursor-pointer px-3 py-2 rounded-xl border text-sm font-medium text-center ${
                                formData[campo.id]
                                  ? "bg-color-secundario text-white border-color-secundario"
                                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
                              } ${!editable || esServicio ? "opacity-50 cursor-not-allowed" : ""}`}
                            >
                              {campo.label}
                            </button>
                          </div>
                        ) : campo.type === "select" ? (
                          <>
                            <label
                              htmlFor={campo.id}
                              className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1"
                            >
                              {campo.label}
                              {campo.required && <span className="text-red-500">*</span>}
                            </label>
                            <select
                              id={campo.id}
                              value={formData[campo.id] || ""}
                              onChange={handleChange}
                              className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                campo.required && editable
                                  ? "border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                                  : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                              }`}
                              disabled={!editable}
                            >
                              <option value="">Seleccione una opción</option>
                              {campo.options?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </>
                        ) : campo.type === "textarea" ? (
                          <>
                            <label
                              htmlFor={campo.id}
                              className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1"
                            >
                              {campo.label}
                              {campo.required && <span className="text-red-500">*</span>}
                            </label>
                            <textarea
                              id={campo.id}
                              className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                campo.required && editable
                                  ? "border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                                  : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                              }`}
                              value={formData[campo.id]}
                              onChange={handleChange}
                              placeholder={campo.placeholder}
                              rows={3}
                              disabled={!editable}
                            />
                          </>
                        ) : (
                          <>
                            <label
                              htmlFor={campo.id}
                              className="text-sm font-medium text-gray-600 mb-1 flex items-center gap-1"
                            >
                              {campo.label}
                              {campo.required && <span className="text-red-500">*</span>}
                            </label>
                            <input
                              type={campo.type}
                              id={campo.id}
                              className={`w-full p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                campo.required && editable
                                  ? "border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                                  : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                              } ${campo.pesableDisabled && formData.es_pesable ? "bg-gray-50 text-gray-400 cursor-not-allowed" : ""}`}
                              value={formData[campo.id] || ""}
                              onChange={handleChange}
                              placeholder={
                                campo.pesableDisabled && formData.es_pesable
                                  ? `Se generará al guardar (${PESABLE.PREFIJO}XXXXX)`
                                  : campo.placeholder
                              }
                              disabled={
                                !editable || campo.disabled || (campo.pesableDisabled && formData.es_pesable) ? true : false
                              }
                            />
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ),
            )}
          </form>

          {tabSeleccionado === "combo" && tab_combo && (
            <div className="space-y-3 mt-6">
              <h2 className="text-lg font-semibold">Productos en el Combo</h2>
              <TablaDinamica
                editable={editable}
                tipo_producto={[1, 2]}
                value={formData.detalleCombo || []}
                fields={[
                  {
                    name: "id_producto",
                    label: "Producto",
                    placeholder: "Seleccione un producto",
                    type: "producto",
                    //funcion: () => setMostrarModalProductoCombo(true),
                    unico: true,
                    //  options: []// productos.map(p => ({ label: p.nombre, value: p.id_producto })),
                  },
                  {
                    name: "cantidad",
                    label: "Cantidad",
                    placeholder: "Cantidad",
                    type: "number",
                  },
                ]}
                camposRequeridos={["id_producto", "cantidad"]}
                onChange={(data) =>
                  setFormData((prev) => ({
                    ...prev,
                    detalleCombo: data,
                  }))
                }
                nombresProductos={nombresProductos}
                setNombresProductos={setNombresProductos}
              />
            </div>
          )}

          {tabSeleccionado === "inventario" && (
            <>
              {/* Sección de detalle inventario con el componente de Tabla Dinamica  */}
              <hr className="mt-6 border-t border-gray-200" />

              <div className="space-y-3">
                <h2 className="text-lg font-semibold">Detalle de inventario</h2>
                <div>
                  <TablaDinamica
                    editable={editable && inventarioEditable}
                    value={formData.detalleInventario || []} // <--- esto es nuevo
                    fields={[
                      {
                        name: "id_sucursal",
                        label: "Sucursal",
                        placeholder: "Sucursal",
                        type: "select",
                        unico: true,
                        options: sucursal.map((sucursal) => ({
                          label: sucursal.descripcion,
                          value: sucursal.id_sucursal,
                        })),
                      },
                      {
                        name: "existencia",
                        label: "Existencia",
                        placeholder: "Existencia",
                        type: "text",
                      },
                      {
                        name: "punto_reorden",
                        label: "Punto reorden",
                        placeholder: "Punto reorden",
                        type: "text",
                      },
                    ]}
                    onChange={(data) => handleChangeInventario(data)}
                    camposRequeridos={["id_sucursal", "existencia"]}
                  />
                </div>
              </div>
            </>
          )}

          {tabSeleccionado === "precios" && tab_precio && (
            <>
              {/* Sección de detalle inventario con el componente de Tabla Dinamica  */}
              <hr className="mt-6 border-t border-gray-200" />

              <div className="space-y-3">
                <h2 className="text-lg font-semibold">Lista de precio</h2>
                <div>
                  <TablaDinamica
                    editable={editable}
                    value={formData.detalleListaPrecio || []} // <--- esto es nuevo
                    fields={[
                      {
                        name: "id_lista_precio",
                        label: "Lista de precio",
                        placeholder: "Lista de precio",
                        type: "select",
                        unico: true,
                        options: listas_precio.map((lista) => ({
                          label: lista.descripcion,
                          value: lista.id_lista_precio,
                        })),
                      },
                      {
                        name: "valor",
                        label: "Valor",
                        placeholder: "Valor",
                        type: "text",
                      },
                    ]}
                    onChange={(data) =>
                      setFormData((prev) => ({
                        ...prev,
                        detalleListaPrecio: data,
                      }))
                    }
                    camposRequeridos={["id_lista_precio", "valor"]}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <DockVerticalDerecha
          handleBotonGuardar={() => SubmitProducto()}
          handleBotonBuscar={() => handleBotonBuscar()}
          handleBotonCrear={() => handleBotonCrear()}
          handleBotonEditar={() => handleBotonEditar()}
          guardando={guardandoProducto}
        />
        <ModalSeleccionCuenta
          mostrar={mostrarModalCuenta}
          onClose={() => setMostrarModalCuenta(false)}
          handleSeleccionCuenta={handleSeleccionCuenta}
          // titulo="Seleccione la cuenta contable débito (CxC)"
          descripcion="Seleccione la cuenta para asignar"
        />
        <PlantillaModal
          mostrar={mostrarModalProducto}
          onClose={cerrarModalProducto}
        >
          <div className="space-y-3">
            {puedeDesactivarProducto && (
              <label className="inline-flex items-center gap-2 text-sm text-gray-600 select-none">
                <input
                  type="checkbox"
                  checked={verProductosDesactivados}
                  onChange={(e) => setVerProductosDesactivados(e.target.checked)}
                  className="rounded border-gray-300 text-color-secundario focus:ring-color-secundario"
                />
                Ver productos desactivados
              </label>
            )}
            <TablaProducto
              descripcion={"Seleccione el producto para ver o editar."}
              setProductoSeleccionado={handleSeleccionarProducto}
              incluirInactivos={verProductosDesactivados}
            />
          </div>
        </PlantillaModal>
        <ModalConfirmacion
          mostrar={confirmacionEstado.mostrar}
          onConfirmar={confirmarCambioEstadoProducto}
          onCancelar={cerrarConfirmacionEstado}
          titulo={confirmacionEstado.titulo}
          mensaje={confirmacionEstado.mensaje}
          textoConfirmar={confirmacionEstado.textoConfirmar}
          tipo={confirmacionEstado.tipo}
        />
        <ModalFlejeProducto
          visible={mostrarModalFleje}
          onCerrar={() => setMostrarModalFleje(false)}
          descripcion={formData.descripcion || ''}
          precio={calcularPrecioTotal(formData.precio, formData.indicador_facturacion)}
          codigoBarra={formData.codigo_barra || ''}
          unidadMedida={
            unidad_medida.find((u) => u.id_unidad_medida === Number(formData.id_unidad_medida))?.descripcion || ''
          }
        />
      </div>
    </div>
  );
}

export default MantenimientoProducto;
